import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext({
    lang: "fr",
    setLang: () => {},
});

const STORAGE_KEY = "mabs_lang";

function initialLang() {
    if (typeof window === "undefined") return "fr";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "fr" || stored === "en") return stored;
    return "fr";
}

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(initialLang);

    const setLang = useCallback((next) => {
        if (next !== "fr" && next !== "en") return;
        setLangState(next);
        try {
            window.localStorage.setItem(STORAGE_KEY, next);
        } catch (_) {
            // ignore quota / private mode
        }
    }, []);

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
